import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";
import { Button, Drawer, Modal } from 'antd';
import axios from 'axios';
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import Cart from './Cart';
import Mininav from './Mininav';

const Header = () => {
    const navigate = useNavigate();
    const { isCartOpen, openCart, closeCart, cartData, fetchCartData } = useCart();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));

    const handleQuickView = async (id) => {
        await fetchCartData();
        axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/viewsinglepage`, { Product_Id: id })
            .then(res => {
                if (res.data && res.data.ProductDetails?.length > 0) {
                    const product = res.data.ProductDetails[0];
                    const cartItem = cartData.find(item => item.Product_Id === product.Product_Id);
                    setSelectedProduct(product);
                    setQuantity(cartItem ? cartItem.Quantity : 1);
                    setIsModalOpen(true);
                }
            })
            .catch(err => {
                // console.error('Error fetching single product:', err);
            });
    };

    const handleAddToCart = () => {
        if (!selectedProduct || !user?.UserID) {
            toast.error('Please log in first');
            setTimeout(() => navigate('/login'), 1500);
            return;
        }
        const data = {
            Product_ID: selectedProduct.Product_Id,
            Category_ID: selectedProduct.Category_Id,
            SubCategory_ID: selectedProduct.SubCategory_Id,
            Quantity: quantity,
            Customer_ID: user.UserID
        };

        axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, data)
            .then(() => {
                toast.success(`Cart updated successfully!`);
                setIsModalOpen(false);
                fetchCartData();
            })
            .catch(err => {
                // console.error('Error updating cart:', err);
                toast.error('Failed to update product in cart');
            });
    };

    const deleteCartItem = async (item) => {
        try {
            const payload = {
                Product_ID: item.Product_Id,
                Customer_ID: user.UserID,
                Category_ID: item.Category_Id,
                SubCategory_ID: item.SubCategory_Id
            };

            await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/deletecartitem`, payload);
            fetchCartData();
        } catch (error) {
            // console.error("Delete failed:", error);
        }
    };

    const updateQuantity = async (item, newQuantity) => {
        try {
            if (newQuantity === 0) {
                await deleteCartItem(item);
            } else {
                const payload = {
                    Product_ID: item.Product_Id,
                    Customer_ID: user.UserID,
                    Category_ID: item.Category_Id,
                    SubCategory_ID: item.SubCategory_Id,
                    Quantity: newQuantity
                };

                await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, payload);
            }

            fetchCartData();
        } catch (error) {
            // console.error("Failed to update quantity:", error);
        }
    };

    const updateModalQuantity = async (newQty) => {
        if (!selectedProduct || !user?.UserID) return;

        setQuantity(newQty);

        const currentCartItem = cartData.find(item => item.Product_Id === selectedProduct.Product_Id);

        if (currentCartItem && currentCartItem.Quantity !== newQty) {
            const payload = {
                Product_ID: selectedProduct.Product_Id,
                Customer_ID: user.UserID,
                Category_ID: selectedProduct.Category_Id,
                SubCategory_ID: selectedProduct.SubCategory_Id,
                Quantity: newQty
            };

            try {
                await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, payload);
                fetchCartData();
            } catch (error) {
                // console.error("Modal quantity update failed:", error);
            }
        }
    };

    const showDrawer = () => {
        openCart();
    };

    const onClose = () => {
        closeCart();
    };

    const getProductQuantity = (productId) => {
        const item = cartData.find(i => i.Product_Id === productId);
        return item ? item.Quantity : 0;
    };

    const totalCartItems = cartData.length;

    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };
    const onHeader = () => {
        navigate('/home');
    }

    return (
        <>
            <ToastContainer />
            <div className="all-main">
                <div className="top-head">
                    <div className="container">
                        
                    </div>
                </div>

                <div className="middle-head-main">
                    <div className="container">
                        <div className="logo-container-main" onClick={onHeader}>
                            {/* <img src="/assets/img/vvdesign-logo.png" alt="logo" className="header-logo-img" /> */}
                            <img src="/assets/img/logo3.png" alt="logo" className="header-logo-img" />

                            <p className="logo-tagline">We craft your imagination</p>
                        </div>
                        <div className="middle-head-inner-main">
                            <div className="middle-head-child">
                                <div className="middle-head-inner-child1">
                                    <Mininav />
                                </div>
                                <div className="middle-head-inner-child">
                                    <IoIosSearch
                                        className='middle-icon'
                                        onClick={() => setShowSearch(true)}
                                    />
                                </div>

                            </div>
                            <div className="middle-head-child">
                                <div className="middle-head-inner-child">


                                    <div className="nav-menu-wrapper">
                                        <ul className="middle-menu">
                                            <li><Link to='/home'>Home</Link></li>
                                            <li className="menu-with-image">
                                                <Link to='/'>Store</Link>
                                                <div className="hover-image-box">
                                                    <div className="div-div-div">
                                                        <div className="img-div">
                                                            <img src="/assets/img/Clock/header1.JPG" alt="" />
                                                            <h3>Resin Art</h3>
                                                        </div>
                                                        <div className="img-div">
                                                            <img src="/assets/img/Bestselling/BS11.jpg" alt="" />
                                                            <h3>Glass Painting</h3>
                                                        </div>
                                                        <div className="img-div">
                                                            <img src="/assets/img/Header3.jpg" alt="" />
                                                            <h3>Alcohol Ink Art</h3>
                                                        </div>
                                                        <div className="img-div">
                                                            <img src="/assets/img/Header4.jpg" alt="" />
                                                            <h3>Pyrography</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li><Link to='/gallery'>Gallery</Link></li>
                                            <li><Link to='/workshop'>Workshop</Link></li>
                                            <li><Link to='/contact'>Contact</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="middle-head-child">
                                <Cart />
                            </div>
                        </div>
                    </div>
                </div>

                {showSearch && (
                    <div className="search-overlay">
                        <div className="search-box">
                            <input type="text" placeholder="Search" />
                            <IoIosSearch className="search-icon" />
                            <span className="close-icon" onClick={() => setShowSearch(false)}>×</span>
                        </div>
                    </div>
                )}
            </div>

           
            <Modal
                title={null}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                centered
                width={800}
            >
                {selectedProduct ? (
                    <div className="modal-layout">
                        <div className="modal-left">
                            <div className="modal-image-box">
                                <img
                                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${selectedProduct.Product_Img}`}
                                    alt={selectedProduct.Product_Name}
                                />
                            </div>
                        </div>
                        <div className="modal-right">
                            <h2 className="product-name">{selectedProduct.Product_Name}</h2>
                            <div className="product-details">
                                <p className="product-category">Category: {selectedProduct.category}</p>
                                <p className="product-subcategory">Subcategory: {selectedProduct.SubCategory}</p>
                            </div>
                            {/* <p className="product-price">₹ {selectedProduct.Rate}</p> */}

                            <div className="cart-qty">
                                <div className="qty-buttons">
                                    <button onClick={() => updateModalQuantity(Math.max(1, quantity - 1))}>-</button>
                                    <span>{quantity}</span>
                                    <button onClick={() => updateModalQuantity(quantity + 1)}>+</button>
                                </div>
                            </div>

                            <button className="add-to-cart" onClick={handleAddToCart}>
                                Add to Cart
                            </button>
                        </div>
                    </div>
                ) : (
                    <p>Loading...</p>
                )}
            </Modal>
        </>
    );
};

export default Header;



